export const DROPDOWN_MENU_SIDE = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
} as const;

export type DropdownMenuSide =
  (typeof DROPDOWN_MENU_SIDE)[keyof typeof DROPDOWN_MENU_SIDE];

export const DROPDOWN_MENU_ALIGN = {
  START: 'start',
  CENTER: 'center',
  END: 'end',
} as const;

export type DropdownMenuAlign =
  (typeof DROPDOWN_MENU_ALIGN)[keyof typeof DROPDOWN_MENU_ALIGN];
